module.exports = __webpack_public_path__ + "img/pd.a9345729.png";